function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import * as React from 'react';
import InlineSvg from './InlineSvg';
import { Link } from 'react-router-dom';

var MobileUserMenu = function (_React$Component) {
  _inherits(MobileUserMenu, _React$Component);

  function MobileUserMenu() {
    _classCallCheck(this, MobileUserMenu);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  MobileUserMenu.prototype.render = function render() {
    var _props = this.props,
        productFamilyId = _props.productFamilyId,
        authUser = _props.authUser;
    var userName = authUser && authUser.name ? authUser.name : '';
    return React.createElement('div', {
      className: 'mobile-menu-footer-flex'
    }, productFamilyId && productFamilyId === 9 ? React.createElement('div', {
      className: 'mobile-menu-footer-flex__user'
    }, React.createElement(Link, {
      to: '/my-account/details'
    }, React.createElement(InlineSvg, {
      name: 'userIcon',
      colour: 'grey'
    }), React.createElement('span', null, userName))) : React.createElement('div', {
      className: 'mobile-menu-footer-flex__user'
    }, React.createElement(InlineSvg, {
      name: 'userIcon',
      colour: 'grey'
    }), React.createElement('span', null, userName)), React.createElement('div', {
      className: 'mobile-menu-footer-flex__links'
    }, productFamilyId && productFamilyId === 9 ? '' : React.createElement(Link, {
      to: '/settings'
    }, React.createElement(InlineSvg, {
      name: 'gear',
      colour: 'grey'
    })), React.createElement(Link, {
      to: '/logout'
    }, React.createElement(InlineSvg, {
      name: 'logout',
      colour: 'grey'
    }))));
  };

  return MobileUserMenu;
}(React.Component);

export default MobileUserMenu;